/* BeyondADS hero carousel + shoppable banner cards.
   Bound by delegation on document: an inline <script> inside a Horizon section
   can render but never bind.

   NO PER-FRAME CARD ANIMATION - deliberately removed.
   The cards carry backdrop-filter (frosted glass). Moving a backdrop-filtered
   element forces the browser to re-sample and re-blur the 4K banner behind it on
   every frame, and animating box-shadow/background alongside it compounds that.
   The travelling highlight lagged badly on real hardware, so it is gone. The
   cards are static; only cheap hover styling from the section CSS remains.
   If motion is ever wanted here again, the frosted glass has to go first.

   The slide change and the indicator fill share ONE accumulator so they cannot
   drift. Elapsed time comes from real clock deltas, not tick counting, so a
   throttled timer still advances correctly.

   The cursor never affects the countdown unless data-pause-hover="1". */
(function(){
  if (window.__bdHeroBound) return;
  window.__bdHeroBound = true;

  var ROOT = '[data-bah-root]';
  var TICK = 40;

  function perf(){ return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function roots(){ return document.querySelectorAll(ROOT); }
  function slides(root){ return root.querySelectorAll('[data-bah-slide]'); }
  function dots(root){ return root.querySelectorAll('[data-bah-dot]'); }
  function curIndex(root){ return parseInt(root.getAttribute('data-current') || '0', 10); }
  function reduced(){ return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function pauseOnHover(root){ return root.getAttribute('data-pause-hover') === '1'; }
  function canHover(){ return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches; }

  /* strip anything an earlier build left inline on the cards */
  function resetPicks(root){
    var picks = root.querySelectorAll('.bah-pick');
    for(var i = 0; i < picks.length; i++){
      var c = picks[i];
      c.classList.remove('is-lit');
      c.style.transform = '';
      c.style.backgroundImage = '';
      c.style.boxShadow = '';
      c.style.borderColor = '';
      c.style.zIndex = '';
      c.style.willChange = '';
      var b = c.querySelector('.bah-pick-add');
      if(b) b.style.transform = '';
    }
  }

  function paintProgress(root, p){
    var ds = dots(root), cur = curIndex(root);
    for(var i = 0; i < ds.length; i++){
      var fill = ds[i].querySelector('[data-bah-fill]');
      if(!fill) continue;
      fill.style.transform = 'scaleX(' + (i === cur ? p : 0) + ')';
    }
  }

  function show(root, i, userDriven){
    var ss = slides(root), ds = dots(root);
    if(!ss.length) return;
    i = ((i % ss.length) + ss.length) % ss.length;
    for(var a = 0; a < ss.length; a++){
      var on = (a === i);
      ss[a].classList.toggle('is-on', on);
      ss[a].setAttribute('aria-hidden', on ? 'false' : 'true');
      var f = ss[a].querySelectorAll('a,button');
      for(var k = 0; k < f.length; k++){
        if(on) f[k].removeAttribute('tabindex');
        else f[k].setAttribute('tabindex', '-1');
      }
    }
    for(var b = 0; b < ds.length; b++){
      ds[b].classList.toggle('on', b === i);
      ds[b].setAttribute('aria-selected', b === i ? 'true' : 'false');
    }
    root.setAttribute('data-current', String(i));
    root.setAttribute('data-ready', '1');
    root.__elapsed = 0;
    paintProgress(root, 0);
    if(userDriven) root.__last = perf();
  }

  function next(root){ show(root, curIndex(root) + 1); }

  function running(root){
    if(document.hidden) return false;
    if(reduced()) return false;
    if(root.__paused) return false;
    return slides(root).length > 1;
  }

  function tick(root){
    var now = perf();
    var dt = now - (root.__last == null ? now : root.__last);
    root.__last = now;
    if(!running(root)) return;
    if(dt < 0 || dt > 2000) dt = TICK;
    root.__elapsed = (root.__elapsed || 0) + dt;
    var dur = root.__dur || 4000;
    var p = root.__elapsed / dur;
    if(p >= 1){ next(root); return; }
    paintProgress(root, p);
  }

  function stop(root){ if(root.__timer){ clearInterval(root.__timer); root.__timer = null; } }
  function start(root){
    stop(root);
    root.__dur = parseInt(root.getAttribute('data-interval') || '4000', 10) || 4000;
    root.__last = perf();
    root.__paused = false;
    if(slides(root).length < 2) return;
    if(reduced()){ paintProgress(root, 0); return; }
    root.__timer = setInterval(function(){ tick(root); }, TICK);
  }

  function init(root){
    if(!root) return;
    resetPicks(root);
    if(root.getAttribute('data-ready') !== '1') show(root, 0);
    start(root);
  }
  function initAll(){ var rs = roots(); for(var i = 0; i < rs.length; i++) init(rs[i]); }

  function rootOf(el){ return (el && el.closest) ? el.closest(ROOT) : null; }

  document.addEventListener('mouseover', function(e){
    var root = rootOf(e.target);
    if(!root || !pauseOnHover(root) || !canHover()) return;
    if(rootOf(e.relatedTarget) === root) return;
    root.__paused = true;
  });
  document.addEventListener('mouseout', function(e){
    var root = rootOf(e.target);
    if(!root || !pauseOnHover(root) || !canHover()) return;
    if(rootOf(e.relatedTarget) === root) return;
    root.__paused = false;
    root.__last = perf();
  });

  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var root = e.target.closest(ROOT);
    if(!root) return;

    var add = e.target.closest('[data-bah-add]');
    if(add){
      e.preventDefault();
      e.stopPropagation();
      if(add.__busy) return;
      var id = parseInt(add.getAttribute('data-vid'), 10);
      if(!id) return;
      add.__busy = true;
      add.classList.add('is-busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function(r){ return r.json(); }).then(function(){
        add.classList.remove('is-busy');
        add.classList.add('is-done');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function(){ add.classList.remove('is-done'); add.__busy = false; }, 1800);
      }).catch(function(){
        add.classList.remove('is-busy');
        add.__busy = false;
      });
      return;
    }

    var dot = e.target.closest('[data-bah-dot]');
    if(dot){
      e.preventDefault();
      show(root, parseInt(dot.getAttribute('data-bah-dot'), 10), true);
    }
  });

  var sx = null, sy = null, sroot = null;
  document.addEventListener('touchstart', function(e){
    var r = rootOf(e.target);
    if(!r || !e.touches.length) return;
    if(e.target.closest && e.target.closest('.bah-pick')) return;
    sroot = r; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, {passive:true});
  document.addEventListener('touchend', function(e){
    if(!sroot || sx === null || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if(Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)){
      show(sroot, curIndex(sroot) + (dx < 0 ? 1 : -1), true);
    }
    sroot = null; sx = null; sy = null;
  }, {passive:true});

  document.addEventListener('visibilitychange', function(){
    var rs = roots();
    for(var i = 0; i < rs.length; i++){ rs[i].__last = perf(); }
  });

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);

  window.__bdHeroTick = function(el){ tick(el || document.querySelector(ROOT)); };
})();
